export const JOB_SET = 'JOB_SET'
export const JOB_LOAD = 'JOB_LOAD'
export const JOB_SUCCESS = 'JOB_SUCCESS'
export const JOB_FAILED = 'JOB_FAILED'
export const JOB_CLEAR = 'JOB_CLEAR'
